import {
  classifierConsumptionUsageProperties,
  classifierGeneralItemField,
} from '../constants/classifier';
import { translateConsumptionUsagePeriodClassificator } from '../utils/translateHelpers';

export const getConsumptionUsageColumns = (t) => [
  {
    title: t('tableGeneral.additional.dateStart'),
    dataIndex: [
      classifierGeneralItemField.PROPERTIES,
      classifierConsumptionUsageProperties.START_DAY,
    ],
  },
  {
    title: t('tableGeneral.additional.dateEnd'),
    dataIndex: [
      classifierGeneralItemField.PROPERTIES,
      classifierConsumptionUsageProperties.END_DAY,
    ],
  },
  {
    title: t('tableGeneral.additional.supportRegulation'),
    dataIndex: [
      classifierGeneralItemField.PROPERTIES,
      classifierConsumptionUsageProperties.SUPPORT_REGULATION,
    ],
  },
  {
    title: t('tableGeneral.additional.period'),
    dataIndex: [
      classifierGeneralItemField.PROPERTIES,
      classifierConsumptionUsageProperties.PERIOD,
    ],
    render: translateConsumptionUsagePeriodClassificator,
  },
  {
    title: t('tableGeneral.additional.subsidyInEnglish'),
    dataIndex: [
      classifierGeneralItemField.PROPERTIES,
      classifierConsumptionUsageProperties.SUBSIDY_IN_ENGLISH,
    ],
  },
  {
    title: t('tableGeneral.additional.subsidyInEstonian'),
    dataIndex: [
      classifierGeneralItemField.PROPERTIES,
      classifierConsumptionUsageProperties.SUBSIDY_IN_ESTONIAN,
    ],
  },
];
